import { ProgressSpinner, TablePagination } from '@repo/atomic-components';
import { useDeactivatedUsersListTable } from './hooks';
import { DeactivatedUsersListTable } from './components';
import { useEffect } from 'react';
import { setActiveUserManagementTab, useAppDispatch, UserManagementTabType } from '@/store';

export const DeactivatedUsersPage = () => {
  const dispatch = useAppDispatch();

  const { table, isTableDataLoading } = useDeactivatedUsersListTable();

  useEffect(() => {
    dispatch(setActiveUserManagementTab(UserManagementTabType.DEACTIVATED));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex h-full w-full flex-col overflow-hidden">
      <div className="relative flex h-full w-full flex-row overflow-hidden">
        <div className="bg-fletchers-white border-fletchers-gray-110 h-full w-full overflow-x-hidden overflow-y-auto rounded-lg border px-2">
          <DeactivatedUsersListTable table={table} />
        </div>

        {isTableDataLoading && (
          <div className="pointer-events-none absolute top-0 left-0 flex h-full w-full items-center justify-center">
            <ProgressSpinner style={{ width: '100px', height: '100px' }} strokeWidth="4" animationDuration="1.5s" />
          </div>
        )}
      </div>
      <div className="mt-auto flex justify-center">
        <TablePagination table={table} appearance={{ dividerClassName: 'hidden' }} />
      </div>
    </div>
  );
};
